import { Swiper, SwiperSlide } from 'swiper/react';
import { useMemo, useState, useEffect } from 'react';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import SwiperCore from 'swiper';
import "../styles/swiper.css"

SwiperCore.use([Autoplay]);

const S3_BASE = 'https://electricthursday-bar-gathering-pictures.s3.us-east-2.amazonaws.com';
const TOTAL_IMAGES = 60;

/** Build S3 image list 001-060; 004-018 use jpeg, rest use jpg (matches rename convention) */
function getS3ImageList(): string[] {
    const list: string[] = [];
    for (let i = 1; i <= TOTAL_IMAGES; i++) {
        const num = String(i).padStart(3, '0');
        const ext = (i >= 4 && i <= 18) ? 'jpeg' : 'jpg';
        list.push(`${S3_BASE}/thursday-bar-gathering-${num}.${ext}`);
    }
    return list;
}

export const EvenSwiper: React.FC = () => {
    const images = useMemo(() => getS3ImageList(), []);
    const [imageOrientations, setImageOrientations] = useState<Record<string, 'landscape' | 'portrait'>>({});

    useEffect(() => {
        if (images.length === 0) return;
        const orientations: Record<string, 'landscape' | 'portrait'> = {};
        let pending = images.length;
        images.forEach((src) => {
            const img = new Image();
            img.onload = () => {
                orientations[src] = img.width > img.height ? 'landscape' : 'portrait';
                pending -= 1;
                if (pending === 0) setImageOrientations((prev) => ({ ...prev, ...orientations }));
            };
            img.onerror = () => {
                pending -= 1;
                if (pending === 0) setImageOrientations((prev) => ({ ...prev, ...orientations }));
            };
            img.src = src;
        });
    }, [images]);

    if (images.length === 0) return <></>;

    return (
        <div className="swiper-section">
            <div className='swiper-button-prev'>
                <img src='/images/icon-prev.png' alt='' />
            </div>
            <Swiper
                modules={[Navigation, Pagination]}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'disable'
                }}
                pagination={{
                    clickable: true,
                }}
                slidesPerView={1}
                spaceBetween={0}
                breakpoints={{ 800: { slidesPerView: 2, spaceBetween: 60 } }}
                autoplay
                loop={true}
            >
                {images.map((item) => {
                    const orientation = imageOrientations[item] || 'portrait';
                    return (
                        <SwiperSlide key={item}>
                            <div className={`swiper-image-container ${orientation === 'landscape' ? 'landscape' : 'portrait'}`}>
                                <img src={item} alt="Thursday bar gathering photo" className="swiper-image" />
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <div className='swiper-button-next'>
                <img src='/images/icon-next.png' alt='' />
            </div>
        </div>
    );
};
